import ClientPortalAdmin from './ClientPortalAdmin';

export default ClientPortalAdmin;
